import { render, staticRenderFns } from "./AltaConsultaComercio.vue?vue&type=template&id=3e3e9b7e"
import script from "./AltaConsultaComercio.vue?vue&type=script&lang=js"
export * from "./AltaConsultaComercio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports